export const ITEMS = [
  {
    id: 1,
    name: 'Work independently',
    description:
      'Don’t wait for others. Do what you say you were going to do. Listen primarily to the customers.',
    background: '#5CC6C7'
  },
  {
    id: 2,
    name: 'Do things really well',
    description: 'Do things with confidence and clarity. Make things people love.',
    background: '#EDCE68'
  },
  {
    id: 3,
    name: 'Set and reach bold goals in alignment with mission',
    description:
      'Believe in, improve upon and care about the mission. Set goals accordingly.',
    background: '#E1718B'
  },
  {
    id: 4,
    name: 'Take initiative',
    description:
      'Act as if nothing would happen unless you make it happen. Come up with actually new ideas regularly and share it with the team.',
    background: '#EDAD68'
  },
  {
    id: 5,
    name: 'Improve yourself and others',
    description:
      'Ask for feedback. Give people feedback so they can improve too. Try to understand others and support them.',
    background: '#C76358'
  },
  {
    id: 6,
    name: 'Pay attention and take responsibility',
    description:
      'Solve problems around you. Prioritize your own tasks. Be aware of both yourself and others.',
    background: '#50AEEB'
  }
];
